import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import patientDashboard from "./patientDashboard.service";

const initialState = {
  totalAppointments: null,
  isLoggedIn: false,
  isError: false,
  isSuccess: false,
  isLoading: false,
  statusMessage: "",
};

export const getTotalAppointments = createAsyncThunk(
  "patientDashboard/getTotalAppointments",
  async (_, thunkAPI) => {
    try {
      return await patientDashboard.getTotalAppointments();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const patientDashboardSlice = createSlice({
  name: "patientDashboard",
  initialState,
  reducers: {
    clearData: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.statusMessage = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTotalAppointments.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getTotalAppointments.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.totalAppointments = action.payload.data;
      })
      .addCase(getTotalAppointments.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.statusMessage = action.payload;
      });
  },
});
export const { clearData } = patientDashboardSlice.actions;

export default patientDashboardSlice.reducer;
